import { z } from 'zod';

import { BooleanParamSchema } from '../../common/boolean-param/boolean-param';
import { UuidSchema } from '../../common/id/id';
import { makeListQuery } from '../../common/list-query/list-query';

/**
 * The whitelisted filters of the test list (N7).
 *
 * **`standaloneOnly` exists because `courseId` cannot ask for "none".** A
 * standalone test (matrix row 4) has a null course, and a filter whose value
 * would have to be absence is exactly the nullable-column trap this layer keeps
 * out of the client's hands — `?courseId=` would arrive as an empty string and
 * mean whatever the clause map happened to do with it.
 *
 * It is deliberately **one-sided**: `true` narrows to standalone tests, and
 * `false` is the same as not asking. A two-sided flag would need a filter entry
 * whose SQL changes with its value, which the shared `ColumnFilter` — one param,
 * one column, one **fixed** operator — cannot express; writing it as one anyway
 * is how a filter ends up silently applying `is null` for both answers.
 */
export const TestsListQuerySchema = makeListQuery({
  isActive: BooleanParamSchema.optional(),
  courseId: UuidSchema.optional(),
  standaloneOnly: BooleanParamSchema.optional(),
  search: z.string().trim().min(1).max(160).optional(),
});

export type TestsListQuery = z.infer<typeof TestsListQuerySchema>;
